module.exports = __webpack_public_path__ + "img/img4.e1098a6b.jpg";